<template>
  <Badge :count="images?.length">
    <el-image :src="thumb" :lazy="lazy" :style="imgStyle" :preview-src-list="images" alt="图片" class="previewsImage-tag">
    </el-image>
  </Badge>
</template>

<script>
import { Badge } from 'ant-design-vue'
export default {
  name: "ImgPreviews",
  components: {
    Badge
  },
  props: {
    images: Array,
    width: {
      type: Number | String,
      default: _ => 80
    },
    height: {
      type: Number | String,
      default: _ => 80
    },
    lazy: {
      type: Boolean,
      default: _ => true
    },
  },
  computed: {
    // images: function () {
    //   console.log(this.images)
    // },
    imgStyle: function () {
      // console.log('width', this.width)
      const w = !!parseInt(this.width) ? parseInt(this.width) : 80
      const h = !!parseInt(this.height) ? parseInt(this.height) : 80
      return {
        "width": !this.isFixed ? `${w}px` : 'auto',
        "height": !this.isFixed ? `${w}px` : 'auto',
        // "margin": '10px'
      }
    },
    thumb() {
      const w = !!parseInt(this.width) ? parseInt(this.width) : 180
      const h = !!parseInt(this.height) ? parseInt(this.height) : 80
      // if (this.images[0].includes('alicdn.com')) {
      //   const thumb = (this.images[0] ?? '').replace(/(\?[^.]*)?$/, `_${200}x${200}.webp`)
      //   return thumb
      // }
      if (this.images[0].includes('static-s.theckb.com')) {
        const thumb = (this.images[0] ?? '').replace(/(\?[^.]*)?$/, `?x-oss-process=image/resize,w_${w},limit_0,/format,webp`)
        return thumb
      }
      return this.images[0]
    },
  },
  data() {
    return {
      isFixed: false,
    }
  },
  // methods: {
  //   getImgUrl(i) {
  //     // console.log('getImgUrl', i)
  //     return this.images[i];
  //     // return `${baseUrl}abstract0${i + 1}.jpg`;
  //   },
  //   changeFixed: function (flag, el) {
  //     if(this.$refs.carouselView && el) {
  //       this.isFixed = this.$refs.carouselView.contains(el.target)
  //     } else {
  //       this.isFixed = true
  //     }
  //   }
  // }
}
</script>

<style scoped></style>
